import React from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { ArrowDownCircleIcon, TicketIcon } from "@heroicons/react/24/solid";
import { CSVLink } from "react-csv";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import useGetScorecardReportDaily from "./hooks/useGetScorecardReportDaily";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import DownloadButton from "../../../../components/DownloadButton";

interface ScorecardReportClosedProps {}

export const ScorecardReportClosed: React.FC<ScorecardReportClosedProps> =
  () => {
    const searchInputsData = {
      Account: "",
      CaseNumber: "",
      Contact: "",
      CreatedBy: "",
      CreatedDate: "",
      ClosedDate: new Date().toLocaleString(),
      Status: "",
      ExcludeStatus: "",
      ActionRequiredOrNotificationC: "",
      ContactId: null,
    };

    const { data: searchScorecard, isLoading: searchScorecardLoading } =
      useGetScorecardReportDaily(searchInputsData);
    const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
    const history = useHistory();
    const userPermissions = useRecoilValue(permissionsSelector);

    let today = new Date().toLocaleString();
    const GetDaysBetweenDates = (d0, d1) => {
      let msPerDay = 8.64e7;
      let x0 = new Date(d0);
      let x1 = new Date(d1);
      return Math.round(
        (x0.setHours(12, 0, 0) - x1.setHours(12, 0, 0)) / msPerDay
      );
    };
    interface IScorecardReportDaily {
      closeReasonC: string;
      createdBy: string;
      caseNumber: string;
      contact: string;
      account: string;
      type: string;
      subject: string;
      policyC: string;
      customerC: string;
      amountC: string;
      actionRequiredOrNotificationC: string;
      generalGroupC: string;
      descriptiveGroupC: string;
      scorecardAreaC: string;
      actionToTakeC: string;
      scorecardAreaOtherC: string;
      writeOffAmountC: string;
      createdDate: string;
      closedDate: string;
      status: string;
      storeNumber: string;
      district: string;
      title: string;
      modifiedDate: string;
      agentUnknownC: string;
      contactId: string;
      state: string;
      districtManager: string;
    }

    //For downloading table data
    const exportdata = searchScorecard?.map((scrd: IScorecardReportDaily) => {
      return {
        Age: scrd.closedDate
          ? GetDaysBetweenDates(scrd.closedDate, scrd.createdDate)
          : GetDaysBetweenDates(today, scrd.createdDate),
        "Store Number": scrd.storeNumber,
        "Office Name": scrd.account,
        State: scrd.state,
        "District Manager": scrd.districtManager,
        District: scrd.district,
        Market: scrd.district,
        "Employee Status": scrd.status,
        Title: scrd.title,
        "Date/Time Opened": scrd.createdDate
          ? new Date(scrd.createdDate)?.toLocaleString()
          : "",
        "Case Date/Time Last Modified": scrd.modifiedDate
          ? new Date(scrd.modifiedDate)?.toLocaleString()
          : "",
        "Date/Time Closed": scrd.closedDate
          ? new Date(scrd.closedDate)?.toLocaleString()
          : "",
        "General Group": scrd.generalGroupC,
        "Descriptive Group": scrd.descriptiveGroupC,
        "Scorecard Area": scrd.scorecardAreaC,
        "Scorecard Area (Other)": scrd.scorecardAreaOtherC,
        "Policy#": scrd.policyC,
        "Customer#": scrd.customerC,
        "Case Number": scrd.caseNumber,
        "Action To Take": scrd.actionToTakeC,
        "Agent Unknown": scrd.agentUnknownC,
        Amount: scrd.amountC,
        "Created By": scrd.createdBy,
        "Case Owner": scrd.createdBy,
        "Contact Name": scrd.contact,
        Status: scrd.status,
        "Employee#": scrd.contactId,
      };
    });

    let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
    const csvReport = {
      filename: "ScorecardReportDaily_" + dateTimeToday + ".csv",
      data: exportdata ? exportdata : [],
    };

    const officeColumns = [
      {
        title: "Age",
        field: "",
        render: (rowData) =>
          rowData.closedDate
            ? GetDaysBetweenDates(rowData.closedDate, rowData.createdDate)
            : GetDaysBetweenDates(today, rowData.createdDate),
      },
      { title: "Store Number", field: "storeNumber" },
      {
        title: "Office Name",
        field: "account",

        render: (rowData) => {
          return (
            <div
              className="cursor-pointer"
              onClick={() => {
                const url = "/officesettings/officesetting";
                history.push({
                  pathname: url,
                  state: {
                    officeId: rowData?.account,
                    action: "ScorecardReportClosed",
                  },
                });
                window.location.reload();
                let userTabs = [
                  {
                    to: "",
                  },
                ];
                [...OfficeTabs].forEach((tabs) => {
                  let temp = [...userPermissions].filter(
                    (user) => user === tabs.permission
                  );
                  if (temp.length > 0)
                    userTabs.push({
                      to: tabs.to,
                    });
                });
                userTabs.shift();
                const index = userTabs.findIndex((c) => c.to === url);
                setSelectedIndex(index);
              }}
            >
              <span className="text-quinary  font-bold underline text-sm ">
                {rowData.account}
              </span>
            </div>
          );
        },
      },
      { title: "State", field: "state" },
      { title: "District Manager", field: "districtManager" },
      { title: "District", field: "district" },
      { title: "Market", field: "district" },
      { title: "Status", field: "status" },
      { title: "Title", field: "title" },
      {
        title: "Date/Time Opened",
        field: "createdDate",
        render: (rowData) =>
          rowData.createdDate
            ? new Date(rowData.createdDate)?.toLocaleString()
            : "",
      },
      {
        title: "Case Date/Time Last Modified",
        field: "modifiedDate",
        render: (rowData) =>
          rowData.modifiedDate
            ? new Date(rowData.modifiedDate)?.toLocaleString()
            : "",
      },

      {
        title: "Date/Time Closed",
        field: "closedDate",
        render: (rowData) =>
          rowData.closedDate
            ? new Date(rowData.closedDate)?.toLocaleString()
            : "",
      },
      { title: "General Group", field: "generalGroupC" },
      { title: "Descriptive Group", field: "descriptiveGroupC" },
      { title: "Scorecard Area", field: "scorecardAreaC" },
      { title: "Scorecard Area (Other)", field: "scorecardAreaOtherC" },
      { title: "Policy#", field: "policyC" },
      { title: "Customer#", field: "customerC" },
      { title: "Case Number", field: "caseNumber" },
      { title: "Action To Take", field: "actionToTakeC" },
      { title: "Amount", field: "amountC" },
      { title: "Agent Unknown", field: "agentUnknownC" },
      { title: "Created By", field: "createdBy" },
      { title: "Case Owner", field: "createdBy" },
      { title: "Employee Name", field: "contact" },
      { title: "Status", field: "status" },
      { title: "Customer#", field: "customerC" },
      { title: "Employee#", field: "contactId" },
    ];

    return (
      <div className="text-xs items-center">
        <div className="">
          <div className="mx-4 mt-4 overflow-x-auto">
            <div className="flex mb-2 gap-2 items-center">
              <div>
                <TicketIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
              </div>
              <div className="flex flex-col leading-tight">
                <div className="text-gray-500 text-md font-medium">
                  Report: Scorecard Report
                </div>
                <div className="flex items-center font-bold text-lg text-primary">
                  Daily Scorecard Report (Closed)
                </div>
              </div>
            </div>
            <div className="mt-2" />
            <div className="flex justify-between">
              <div className="flex items-center gap-1">
                <span className="text-gray-500 text-sm">Total Records: </span>
                <span className="text-primary text-base font-semibold">
                  {searchScorecard?.length}
                </span>
              </div>
              <CSVLink {...csvReport}>
                <DownloadButton
                  buttonValue="Download File"
                  onClick={() => exportdata()}
                  className={undefined}
                  disabled={undefined}
                />
              </CSVLink>
            </div>
          </div>
          <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
            <MaterialTableTS
              data={searchScorecard}
              isLoading={searchScorecardLoading}
              columns={officeColumns}
              showTitle={false}
            />
          </div>
        </div>
      </div>
    );
  };
